var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spa-reservation-info" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("h2", { staticClass: "spa-reservation-info__title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.reservationDetailsData.propertyData.facilityName) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "spa-reservation-info__details" }, [
          _vm.reservationDetailsData.confirmationCode
            ? _c("div", { staticClass: "spa-reservation-info__detail" }, [
                _c("span", { staticClass: "spa-reservation-info__label" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.tc(
                          "spaSoft.reservationdetails.confirmationCodeLabel"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "spa-reservation-info__value" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.reservationDetailsData.confirmationCode) +
                      "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "spa-reservation-info__detail" }, [
            _c("span", { staticClass: "spa-reservation-info__label" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.tc("spaSoft.reservationdetails.date")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "spa-reservation-info__value" }, [
              _vm._v(_vm._s(_vm.dateFormatted)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "spa-reservation-info__detail" }, [
            _c("span", { staticClass: "spa-reservation-info__label" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.tc("spaSoft.reservationdetails.time")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "spa-reservation-info__value" }, [
              _vm._v(_vm._s(_vm.timeRangeFormatted)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "spa-reservation-info__property-btn",
              class: { "is-active": _vm.isPropertyDetailsOpen },
              on: { click: _vm.togglePropertyDetails },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.tc("spaSoft.reservationdetails.propertyDetailsCta")
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "expand-y" } }, [
          _vm.isPropertyDetailsOpen
            ? _c(
                "div",
                { staticClass: "spa-reservation-info__property-details" },
                [
                  _c("div", { staticClass: "spa-reservation-info__contact" }, [
                    _vm.reservationDetailsData.propertyData.address
                      ? _c(
                          "p",
                          { staticClass: "spa-reservation-info__address" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.reservationDetailsData.propertyData
                                    .address
                                ) +
                                "\n            " +
                                _vm._s(
                                  _vm.reservationDetailsData.propertyData.city
                                    ? ","
                                    : ""
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.reservationDetailsData.propertyData.city
                      ? _c("p", { staticClass: "spa-reservation-info__city" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.reservationDetailsData.propertyData.city
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.reservationDetailsData.propertyData.phone
                      ? _c(
                          "a",
                          {
                            staticClass: "spa-reservation-info__phone",
                            attrs: {
                              href:
                                "tel:" +
                                _vm.reservationDetailsData.propertyData.phone,
                            },
                          },
                          [
                            _c("span", { staticClass: "icon-phone-white" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.reservationDetailsData.propertyData.phone
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.reservationDetailsData.propertyData.email
                      ? _c(
                          "a",
                          {
                            staticClass: "spa-reservation-info__email",
                            attrs: {
                              href:
                                "mailto:" +
                                _vm.reservationDetailsData.propertyData.email,
                            },
                          },
                          [
                            _c("span", { staticClass: "icon-envelope-white" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.reservationDetailsData.propertyData.email
                                ) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "spa-reservation-info__map" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "map-frame map property google-map component",
                      },
                      [
                        _c("google-map", {
                          attrs: {
                            properties: [
                              {
                                Title:
                                  _vm.reservationDetailsData.propertyData
                                    .facilityName,
                                Latitude:
                                  _vm.reservationDetailsData.propertyData
                                    .latitude,
                                Longitude:
                                  _vm.reservationDetailsData.propertyData
                                    .longitude,
                                Description:
                                  _vm.reservationDetailsData.propertyData
                                    .description,
                                Link:
                                  "https://www.google.com/maps/search/?api=1&query=" +
                                  _vm.reservationDetailsData.propertyData
                                    .latitude +
                                  "," +
                                  _vm.reservationDetailsData.propertyData
                                    .longitude,
                                Image:
                                  _vm.reservationDetailsData.propertyData
                                    .imageSrc,
                              },
                            ],
                            options: {
                              ApiKey: _vm.mapOptions.ApiKey,
                              Latitude:
                                _vm.reservationDetailsData.propertyData
                                  .latitude,
                              Longitude:
                                _vm.reservationDetailsData.propertyData
                                  .longitude,
                              CtaButtonTitle: _vm.mapOptions.CtaButtonTitle,
                              ZoomLevel: _vm.mapOptions.ZoomLevel,
                              MapType: _vm.mapOptions.MapType,
                              MapId: _vm.mapOptions.MapId,
                              MarkerColor: _vm.mapOptions.MarkerColor,
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }